import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><g><path style={{
      fill: "#41479B"
    }} d="M512,126.621c0-21.177-17.167-38.345-38.345-38.345H38.345C17.167,88.276,0,105.443,0,126.621   v28.745h512V126.621z" /><path style={{
      fill: "#41479B"
    }} d="M38.345,423.724h435.31c21.177,0,38.345-17.167,38.345-38.345v-28.745H0v28.745   C0,406.557,17.167,423.724,38.345,423.724z" /></g><rect y={155.37} style={{
    fill: "#F5F5F5"
  }} width={512} height={67.09} /><rect y={222.46} style={{
    fill: "#41479B"
  }} width={512} height={67.09} /><rect y={289.55} style={{
    fill: "#F5F5F5"
  }} width={512} height={67.09} /><path style={{
    fill: "#FF4B55"
  }} d="M13.9,414.921l244.814-155.049c2.841-1.8,2.841-5.945,0-7.745L13.899,97.079  C5.409,104.113,0,114.734,0,126.621V385.38C0,397.266,5.409,407.887,13.9,414.921z" /><path style={{
    fill: "#F5F5F5"
  }} d="M88.526,213.441l9.064,27.176l28.647,0.222c2.219,0.018,3.139,2.849,1.354,4.168l-23.046,17.018  l8.641,27.313c0.67,2.116-1.74,3.866-3.545,2.575l-23.306-16.658l-23.306,16.658c-1.805,1.291-4.215-0.46-3.545-2.575l8.641-27.313  L45.08,245.007c-1.785-1.319-0.865-4.151,1.354-4.168l28.647-0.222l9.064-27.176C84.846,211.336,87.825,211.336,88.526,213.441z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };